import React from "react"
import SbEditable from "storyblok-react"
import { blokType } from "../../types"

import { HeroLeftCmp, HeroLeftProps } from "./HeroLeft"

interface HeroLeftWrapperBlokProps {
  blok: HeroLeftProps & blokType
}

const HeroLeft: React.FC<HeroLeftWrapperBlokProps> = ({ blok }) => (
  <SbEditable content={blok}>
    <HeroLeftCmp
      icon={blok.icon}
      label={blok.label}
      title={blok.title}
      description={blok.description}
      cta_button={blok.cta_button}
      background_image={blok.background_image}
      background_color={blok.background_color}
      id={blok._uid}
      custom_id={blok.custom_id}
    />
  </SbEditable>
)

export default HeroLeft
